import React from "react";
import { BsCarFront } from "react-icons/bs";
import { MdVerified } from "react-icons/md";
import { FaRegCheckCircle } from "react-icons/fa";
import styles from "./BookingSuccess.module.css";
import { Service, Vehicle } from "../types";

interface BookingSuccessProps {
  service: Service;
  vehicle: Vehicle;
  onDone: () => void;
}

export default function BookingSuccess({
  service,
  vehicle,
  onDone,
}: BookingSuccessProps) {
  return (
    <div id="booking-success-container" className={styles.container}>
      <div className={styles.successIconContainer}>
        <FaRegCheckCircle size={40} />
      </div>

      <h2 id="booking-success-title" className={styles.title}>
        Booking Confirmed!
      </h2>
      <p className={styles.subtitle}>
        Your appointment has been successfully scheduled. A confirmation and
        service details have been sent to your registered profile.
      </p>

      <div className={styles.detailsCard}>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Service Ordered</span>
          <span className={styles.detailValue}>{service.title}</span>
        </div>

        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Assigned Vehicle</span>
          <span className={styles.detailValue}>
            {vehicle.year} {vehicle.make} {vehicle.model}
          </span>
        </div>

        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Estimated Time</span>
          <span className={styles.detailValue}>{service.approxTime}</span>
        </div>

        <div
          style={{ height: "1px", backgroundColor: "#e2e8f0", margin: "4px 0" }}
        />

        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>Total Amount</span>
          <span className={`${styles.detailValue} ${styles.priceValue}`}>
            ${service.offer_price.toFixed(2)}
          </span>
        </div>
      </div>

      <button
        id="success-done-btn"
        className={styles.closeButton}
        onClick={onDone}
      >
        Done & Back to Services
      </button>
    </div>
  );
}
